/* Colour image swatches on collection/search product cards */
(function(){
  if (window.__aiCollSw) return; window.__aiCollSw = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cache = {};
  var COLOUR = /^(colou?r|farve|color)$/i;
  var WIDTHS = [165, 360, 533, 720, 940, 1066];
  function getProduct(h){
    if (!cache[h]) cache[h] = fetch(root + 'products/' + h + '.js', {credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    return cache[h];
  }
  function abs(src){ return !src ? '' : (src.indexOf('//') === 0 ? 'https:' + src : src); }
  function sized(src, w){ src = abs(src); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function maxFor(row){ return window.matchMedia('(max-width: 749px)').matches ? 4 : 5; }
  function setImage(card, src){
    var img = card.querySelector('.card__media img');
    if (!img || !src) return;
    img.srcset = WIDTHS.map(function(w){ return sized(src, w) + ' ' + w + 'w'; }).join(', ');
    img.src = sized(src, 533);
  }
  function setLinks(card, url){
    card.querySelectorAll('a.full-unstyled-link').forEach(function(a){ a.href = url; });
  }
  function build(wrapper){
    if (wrapper.getAttribute('data-ai-cs')) return;
    wrapper.setAttribute('data-ai-cs', '1');
    var link = wrapper.querySelector('a.full-unstyled-link');
    var info = wrapper.querySelector('.card > .card__content > .card__information');
    if (!link || !info) return;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
    if (!m) return;
    var row = document.createElement('div');
    row.className = 'ai-cs';
    info.parentNode.insertBefore(row, info);
    var baseHref = link.getAttribute('href').split('?')[0];
    var img = wrapper.querySelector('.card__media img');
    var orig = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') } : null;
    getProduct(m[1]).then(function(p){
      if (!p || !p.variants) return;
      var idx = -1;
      (p.options || []).forEach(function(o, i){ var n = typeof o === 'string' ? o : o.name; if (COLOUR.test((n || '').trim())) idx = i; });
      if (idx < 0) return;
      var seen = {}, list = [];
      p.variants.forEach(function(v){
        var val = v.options[idx];
        if (seen[val]) { if (!seen[val].img && v.featured_image) seen[val].img = v.featured_image.src; return; }
        seen[val] = { name: val, id: v.id, img: v.featured_image ? v.featured_image.src : null, avail: v.available };
        list.push(seen[val]);
      });
      list.forEach(function(c){ if (!c.img) c.img = p.featured_image; });
      var max = maxFor(row), shown = list.slice(0, max), selected = null;
      shown.forEach(function(c){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'ai-cs__sw';
        b.setAttribute('aria-label', c.name); b.title = c.name;
        b.innerHTML = '<img loading="lazy" alt="" width="68" height="84">';
        b.firstChild.src = sized(c.img, 120);
        b.addEventListener('mouseenter', function(){ setImage(wrapper, c.img); });
        b.addEventListener('mouseleave', function(){
          if (selected) setImage(wrapper, selected.img);
          else if (img && orig) { img.srcset = orig.srcset || ''; img.src = orig.src; }
        });
        b.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();
          selected = c;
          row.querySelectorAll('.ai-cs__sw').forEach(function(x){ x.classList.remove('is-on'); });
          b.classList.add('is-on');
          setImage(wrapper, c.img);
          setLinks(wrapper, baseHref + '?variant=' + c.id);
        });
        row.appendChild(b);
      });
      if (list.length > max) {
        var more = document.createElement('a');
        more.className = 'ai-cs__more'; more.href = baseHref;
        more.textContent = '+' + (list.length - max);
        more.setAttribute('aria-label', (list.length - max) + ' flere farver');
        row.appendChild(more);
      }
    });
  }
  function scan(){ document.querySelectorAll('.product-grid .card-wrapper').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var t; new MutationObserver(function(){ clearTimeout(t); t = setTimeout(scan, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
